import {
  JOB_COMPLETED_REQUEST,
  JOB_COMPLETED_SUCCESS,
  INITIALIZE_MESSAGE,
} from '../../constants/ActionTypes'

const initialState = {
  jobSuccessMessage: '',
  isJobCompletedLoading: false,
};

export default (state = initialState, action) => {
  state = {
    ...state,
    jobSuccessMessage: '',
  }

  switch (action.type) {
    case JOB_COMPLETED_REQUEST:
      return {
        ...state,
        isJobCompletedLoading: true,
        jobSuccessMessage: initialState.jobSuccessMessage,
      }
    case JOB_COMPLETED_SUCCESS:
      return {
        ...state,
        isJobCompletedLoading: false,
        jobSuccessMessage: action.payload.message,
      }
    case INITIALIZE_MESSAGE:
      return {
        ...state,
        isJobCompletedLoading: false,
        jobSuccessMessage: initialState.jobSuccessMessage,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/broadcasting.js